import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { AdminHeaderComponent, AdminToastHostComponent } from '@cnt-admin/ui';
import { IonApp, IonMenu, IonRouterOutlet, IonSplitPane } from '@ionic/angular/standalone';
import { filter } from 'rxjs';

@Component({
  selector: 'curbnturf-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [AdminHeaderComponent, AdminToastHostComponent, IonApp, IonMenu, IonRouterOutlet, IonSplitPane],
})
export class AppComponent {
  title = 'curbnturf-admin';

  /** The sign-in screens (auth/login, auth/redirect) render without the side menu. */
  onAuthPage = false;

  constructor() {
    inject(Router)
      .events.pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        takeUntilDestroyed(),
      )
      .subscribe((e) => (this.onAuthPage = e.urlAfterRedirects.startsWith('/auth/')));
  }
}
